import { Address } from '../../../../types/common/address';
import { toFilterString } from '../../../../util/string.util';

export class AddressFilter {
  search(query: string, item?: Address) {
    if (!item) return false;

    if (
      toFilterString(item.addressLine1).includes(query) ||
      toFilterString(item.addressLine2).includes(query) ||
      toFilterString(item.city).includes(query) ||
      toFilterString(item.region).includes(query) ||
      toFilterString(item.postalCode).includes(query)
    ) {
      return true;
    }

    return false;
  }
}
